import { Component, OnInit } from '@angular/core';
import { GanttService } from '../../services/gantt.service';
import { GanttLoaderService } from '../../services/gantt-loader.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PesquisaGeralService } from 'src/app/modules/projeto-completo/services/pesquisa-geral.service';
import { BaseListComponent } from 'src/app/base/components/base-list.component';

@Component({
  selector: 'app-projeto-gantt',
  templateUrl: './projeto-gantt.component.html',
  styleUrls: ['./projeto-gantt.component.scss']
})
export class ProjetoGanttComponent extends BaseListComponent<any> implements OnInit {

  id:number|null = null;
  history:number|null = null;
  header: any = [
    {"id": "empty", "name": "", "width": "50px", "type": "edit"},
    {"id": "status", "name": "Status", "width": "25px", "type": "status", "edit": false},
    {"id": "statusBaseLine", "name": "Monitoramento", "width": "25px", "type": "statusBaseLine", "edit": false},
    {"name": 'Dados', "width": "100%", "type": "session", "showInTable":false, "edit": true},
    {"id": "name", "name": "Nome", "title": "Nome", "width": "300px", "type": "input", "edit": true, "inputType": "text", "expand": true, "modalClass": "col-12"},
    {"id": "startIsMilestone", "name": "É um Marco Inicial", "title": "Data de início é um Marco", "width": "70px", "type": "milestone", "edit": true, "inputType": "checkbox", "modalClass": "col-3", "tableClass":"font-icon-fill text-center"},
    {"id": "start", "name": "Início", "width": "80px", "title": "Data de início", "type": "input", "edit": true, "inputType": "date", "modalClass": "col-3"},
    {"id": "startBaseLine", "name": "Início Linha Base", "width": "80px", "title": "Data de início da linha base", "type": "dateBaseline", "edit": false, "inputType": "date", "modalClass": "col-3"},
    {"id": "endIsMilestone", "name": "É um Marco Final", "title": "Data de fim é um Marco", "width": "70px", "type": "milestone", "edit": true, "inputType": "checkbox", "modalClass": "col-3", "tableClass":"font-icon-fill text-center"},
    {"id": "end", "name": "Fim", "width": "80px", "title": "Data de fim", "type": "input", "edit": true, "inputType": "date", "modalClass": "col-3"},
    {"id": "endBaseLine", "name": "Fim Linha Base", "width": "80px", "title": "Data de fim Linha Base", "type": "dateBaseline", "edit": false, "inputType": "date", "modalClass": "col-3"},
    {"id": "diffDays", "name": "Dias de atraso projetados", "width": "80px", "title": "Dias de atraso projetados", "type": "diffDays", "edit": false, 'showInModal':false, "modalClass": "col-3"},
    {"id": "duration", "name": "Duração", "width": "80px", "title": "Duração", "type": "input", "edit": true, "inputType": "number", "modalClass": "col-4", 'showInModal':false},
    {"id": "agency_id", "name": "Responsável", "width": "80px", "title": "Responsável", "type": "select", "edit": true, "modalClass": "col-6", 'showInTable':false, 'optionsKey':'agencies'},
    {"name": 'Configurar atualização', "width": "100%", "type": "session", "showInTable":false, "edit": true},
    {"id": "relevance", "name": "Peso para ponderação", "width": "80px", "title": "", "type": "input", "edit": true, "inputType": "number", "modalClass": "col-3", "tableClass":"text-center", 'showInTable':false},
    {"id": "progress_compute_type", "name": "Medição de progresso da etapa",  "title": "Medição de progresso", "type": "progress", "edit": true, "modalClass": "col-5", 'showInTable':false},
    {"id": "progress", "name": "Progresso", "width": "80px", "title": "%", "type": "input", "edit": true, "inputType": "number", "modalClass": "col-2", "tableClass":"text-center", "inputAttr": {min: 0, max: 100}},
    {"id": "monitoring_type", "name": "Periodicidade", "width": "80px", "title": "Periodicidade", "type": "typeMonitoring", "edit": true, "modalClass": "col-4", 'showInTable':false},
    {"id": "task_notification_ind", "name": "Receber notificações", "width": "80px", "title": "Receber Notificações", "type": "notification", "edit": true, "modalClass": "col-3", 'showInTable':false},
    {"id": "manager_main", "name": "Usuário Responsável", "width": "80px", "title": "Usuário Responsável", "type": "select", "edit": true, "modalClass": "col-7", 'showInTable':false, 'optionsKey':'assigns'},
    {"id": "status", "name": "Status", "width": "80px", "title": "Status", "type": "input", "edit": false, "inputType": "status", 'showInTable':false},
    {"id": "depends", "name": "Dependências", "width": "80px", "title": "", "type": "input", "edit": true, "inputType": "text", 'showInModal':false},
    {"id": "pf_prt_issue_critical_all_count", "name": "PC", "width": "40px", "title": "Ponto crítico", "type": "pc", "edit": false, 'showInModal':false},
  ];
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private pesquisaGeralService: PesquisaGeralService,
    private ganttService: GanttService,
    private ganttLoaderService: GanttLoaderService,
  ) { 
    super();
  }

  ngOnInit() {
    this.ganttLoaderService.setLoad();
    this.pesquisaGeralService.info.subscribe(info => {
      const infoProjeto = info;
      this.id = infoProjeto.id;
      this.route.queryParamMap.subscribe(params => {
        this.history = +params.get("history");
        this.saveQueryParams();
        this.loadGantt();
      });
    });
    
  }

  loadGantt(): void {
    this.ganttService.getProjeto(this.id,this.history).subscribe({
      next: (dados) => {
        this.ganttLoaderService.startGantt({
          ...dados,
          header: this.header,
          hostApp: dados['hostApp'],
          saveData: this.saveData.bind(this),
          changeHistory: this.changeHistory.bind(this)
        });
      },
      error: (err) => {
        alert(err?.error || 'Erro ao carregar o Gantt');
      }
    });
  }

  saveData(data:any): void{
    this.ganttLoaderService?.setLoad();
    let params = new URLSearchParams(document.location.search);
    let id = params.get("pf_id");
    this.ganttService.update(data,this.id).subscribe({
      next: (dados) => {
        this.ganttLoaderService?.removeLoad();
        const url = new URL(window.location.href);
        this.confirmation("Salvo com sucesso").subscribe(() => {
          window.location.href = url.toString()
        });
      },
      error: (err) => {
        this.ganttLoaderService?.removeLoad();
        this.msgError('Erro ao Salvar');
        console.error("Erro ao salvar. (" + err?.responseJSON?.error?.toString() + ")");
      }
    });
  }

  changeHistory(id){
    const url = new URL(window.location.href);
    url.searchParams.set('history', id);
    window.location.href = url.toString();
  }

  saveQueryParams() {
    let queryParams = { pf_id: this.id };
    if(this.history){
      queryParams['history'] = this.history
    }
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }
}
